import * as React from "react"
import type { SVGProps } from "react"
const SvgCamera = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <g fillRule="evenodd" clipRule="evenodd">
      <path d="M8 6.168a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-1.5 2.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" />
      <path d="M6.333 2.168a.5.5 0 0 0-.384.18l-1.517 1.82H2.667A1.833 1.833 0 0 0 .833 6.001v6a1.834 1.834 0 0 0 1.834 1.834h10.666A1.833 1.833 0 0 0 15.167 12v-6a1.833 1.833 0 0 0-1.834-1.833h-1.766l-1.516-1.82a.5.5 0 0 0-.384-.18zm-1.282 2.82 1.516-1.82h2.865l1.517 1.82a.5.5 0 0 0 .384.18h2a.833.833 0 0 1 .834.833v6a.833.833 0 0 1-.834.834H2.667A.834.834 0 0 1 1.833 12v-6a.833.833 0 0 1 .834-.833h2a.5.5 0 0 0 .384-.18" />
    </g>
  </svg>
)
export default SvgCamera
